var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-layout',[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-row',[_c('v-col',[_c('index')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }